// extracted by mini-css-extract-plugin
module.exports = {"form":"HelpDeskPage_form__2Stkh"};